import { useCurrentWidth } from './useCurrentWidth';
import sassVars from '@higherlogic/ocfe/styles/sass-variables.scss';

export const useIsStackedColumn = () => {
  const { width } = useCurrentWidth();
  return width < sassVars.legacyStackBreakpoint;
};
